import { VStack, Text, DataList, DataItem } from '@cad-arc';
import { UnitStatusSearchRow } from '@mark43/cad-api';
import { ExpandableContent } from './expandable-content';

export function UnitStatusSearchResultsStatusCell({
    row,
    isExpanded,
}: {
    row: UnitStatusSearchRow;
    isExpanded: boolean;
}) {
    return (
        <VStack align="left">
            <Text fontWeight="bold">{row.unitState}</Text>
            <ExpandableContent isExpanded={isExpanded}>
                {row.transitionedBy && (
                    <DataList>
                        <DataItem dataKey="Transitioned By">{row.transitionedBy}</DataItem>
                        {row.assignmentTypes &&
                            row.assignmentTypes.length > 0 &&
                            row.assignmentTypes.map((status, idx) => (
                                <Text key={idx}>{status}</Text>
                            ))}
                        {row.comments &&
                            row.comments.length > 0 &&
                            row.comments.map((comment, idx) => (
                                <Text
                                    isItalic
                                    key={idx}
                                    style={{
                                        maxWidth: 200,
                                        wordWrap: 'break-word',
                                        whiteSpace: 'normal',
                                    }}
                                >
                                    {comment}
                                </Text>
                            ))}
                    </DataList>
                )}
            </ExpandableContent>
        </VStack>
    );
}
